<quill-editor
  format="html"
  [modules]="quillConfig"
  [styles]="editorStyle"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [required]="field.props.required ?? false"
  [placeholder]="field.props.placeholder ?? ''">
</quill-editor>
